export default [
  {
    name: 'trilha-presencial',
    path: '/settings/trilha-presencial',
    component: () => import(/* webpackChunkName: "trilha-presencial" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Trilha presencial',
      icon: 'mdi-map-marker-path',
      label: 'Trilha presencial',
      roles: ['Admin']
    }
  }
]
